/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Save_SuccessInputs */

const vi_sidebar_layout_save_success = /** @type {(inputs: Sidebar_Layout_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thứ tự menu`)
};

/**

* @param {Sidebar_Layout_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_save_success = /** @type {((inputs?: Sidebar_Layout_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_save_success(inputs)
});